(() => {
  if (window.__gptSizeChartDelegationReady) return;
  window.__gptSizeChartDelegationReady = true;

  const rootFor = element => element?.closest?.('[data-size-chart-root]');

  function open(root) {
    if (!root) return;
    document.querySelectorAll('[data-size-chart-root].is-open').forEach(other => {
      if (other !== root) close(other, false);
    });

    const trigger = root.querySelector('[data-size-chart-trigger]');
    const modal = root.querySelector('[data-size-chart-modal]');
    const overlay = root.querySelector('[data-size-chart-overlay]');
    if (!trigger || !modal || !overlay) return;

    root.__sizeChartPreviousFocus = document.activeElement;
    root.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    modal.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gpt-size-chart-open');

    requestAnimationFrame(() => root.querySelector('[data-size-chart-close]')?.focus());
  }

  function close(root, restoreFocus = true) {
    if (!root) return;
    const trigger = root.querySelector('[data-size-chart-trigger]');
    const modal = root.querySelector('[data-size-chart-modal]');
    const overlay = root.querySelector('[data-size-chart-overlay]');

    root.classList.remove('is-open');
    trigger?.setAttribute('aria-expanded', 'false');
    modal?.setAttribute('aria-hidden', 'true');
    overlay?.setAttribute('aria-hidden', 'true');

    if (!document.querySelector('[data-size-chart-root].is-open')) {
      document.body.classList.remove('gpt-size-chart-open');
    }

    if (restoreFocus) {
      const target = root.__sizeChartPreviousFocus;
      if (target?.isConnected) target.focus();
      else trigger?.focus();
    }
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-size-chart-trigger]');
    if (trigger) {
      event.preventDefault();
      open(rootFor(trigger));
      return;
    }

    const closer = event.target.closest('[data-size-chart-close], [data-size-chart-overlay]');
    if (closer) {
      event.preventDefault();
      close(rootFor(closer));
    }
  });

  document.addEventListener('keydown', event => {
    const root = document.querySelector('[data-size-chart-root].is-open');
    if (!root) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close(root);
      return;
    }

    if (event.key !== 'Tab') return;
    const modal = root.querySelector('[data-size-chart-modal]');
    const focusable = [...modal.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')]
      .filter(element => !element.disabled && element.offsetParent !== null);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:unload', () => {
    document.body.classList.remove('gpt-size-chart-open');
  });
})();
